module.exports = __webpack_public_path__ + "themes/non-default/holdingsAsset.8cdcca6d1b5ee83e2365eeab1e5369d3.png";